import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, Inject, OnInit, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedModule} from "@shared/shared.module";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'rlst-redeem-credit-overlay',
  standalone: true,
  imports: [CommonModule, SharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './redeem-credit-overlay.component.html',
  styleUrls: ['./redeem-credit-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RedeemCreditOverlayComponent implements OnInit {
  @Input() availableCredits: number = 0;
  @Input() visible: boolean = false;
  @Input() showCloseButton: boolean = false;
  @Output() redeemConfirmed: EventEmitter<void> = new EventEmitter<void>();
  @Output() closed: EventEmitter<void> = new EventEmitter<void>();


  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) private readonly data: { availableCredits?: number; showCloseButton?: boolean } | null,
    @Optional() private readonly dialogRef?: MatDialogRef<RedeemCreditOverlayComponent>
  ) {}

  ngOnInit(): void {
    // If opened as a MatLegacyDialog, the data payload will be injected — use it to seed inputs.
    if (this.data) {
      if (typeof this.data.availableCredits === 'number') this.availableCredits = this.data.availableCredits;
      if (typeof this.data.showCloseButton === 'boolean') this.showCloseButton = this.data.showCloseButton;
      // When used as a dialog, ensure visible is true so the en-modal opens
      this.visible = true;
    }
  }

  public confirm(): void {
    if (this.dialogRef) {
      this.dialogRef.close(true);
    } else {
      this.redeemConfirmed.emit();
    }
  }

  public close(): void {
    if (this.dialogRef) {
      this.dialogRef.close(false);
    } else {
      this.closed.emit();
    }
  }
}

